import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import TFUSelect from "../based/inputs/TFUSelect";
import ReadyListServices from "../based/services/ReadyListServices";
import UserServices from "../based/services/PartnerServices";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";

function AddProductModal({ show, onClose, onSave, partnerId }) {
    const [datas, setDatas] = useState([]);
    const [productId, setProductId] = useState("");

    console.log("partnerId", partnerId);

    useEffect(() => {
        getProduct("");
    }, []);

    const getProduct = async (keyword) => {
        const [err, data] = await ReadyListServices.GetReadyProductOptions(0, keyword);
        if (!err && data) {
            let options = data.map((item) => ({
                value: item.id,
                text: item.name,
                label: item.name,
            }));
            setDatas(options);
        } else {
            setDatas([]);
        }
    };

    const handleProduct = async (productId) => {
        const [err, data] = await UserServices.AddProductPartner({ partnerId: partnerId, productId: productId });
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Thêm sản phẩm thành công");
            onSave();
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Thêm sản phẩm thất bại");
        }
    };

    return (
        <Wrapper>
            <CommonModal
                show={show}
                onClose={onClose}
                title="Thêm Partner"
                hideOnClose
                customButton={
                    <div className="list-action">
                        <button className="btn btn-danger m-1" onClick={onClose}>
                            Đóng
                        </button>
                        <button
                            className="btn btn-custom m-1"
                            onClick={(e) => {
                                handleProduct(productId);
                            }}
                        >
                            Xác nhận
                        </button>
                    </div>
                }
            >
                <div className="list-row">
                    <div className="row-item">
                        <label htmlFor="">Chọn sản phẩm</label>
                        <TFUSelect
                            placeholder="Chọn tài khoản"
                            options={datas}
                            value={productId}
                            onChanged={(value) => {
                                handleProduct(+value);
                            }}
                            name="partnerUserId"
                            handleInputChange={(value) => {
                                getProduct(value);
                            }}
                            required
                        />
                    </div>
                </div>
            </CommonModal>
        </Wrapper>
    );
}

export default AddProductModal;

const Wrapper = styled.div``;
